import { useEffect } from "react";

function useShowJSD({ isAuth = false }) {
  useEffect(() => {
    const jsdWidget = document.querySelector("#jsd-widget");

    if (jsdWidget instanceof HTMLElement) {
      if (isAuth) {
        jsdWidget.style.visibility = "visible";
      } else {
        jsdWidget.style.visibility = "hidden";
      }
    }
  }, [isAuth]);
}

export default useShowJSD;
